(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kfz-accessory-product"] && !Shopify.designMode) return;
  try {
    
  function setupAccessory(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('.kfx-form');
    const input = form.querySelector('[name="quantity"]');
    // In den Warenkorb legen und das Seitenfenster öffnen, statt zur
    // Warenkorbseite zu wechseln - wie im Konfigurator. Ohne Fenster oder bei
    // einem Netzfehler schickt das Formular wie bisher ab.
    const addButton = form.querySelector('.kfx-add');
    const errorBox = form.querySelector('.kfx-error');
    form.addEventListener('submit', async event => {
      if (!window.KfzCartDrawer || !window.fetch) return;
      event.preventDefault();
      const label = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = 'Wird hinzugefügt …';
      if (errorBox) errorBox.hidden = true;
      try {
        const response = await fetch(form.getAttribute('action').replace(/\/?$/, '') + '.js', {
          method: 'POST',
          headers: {'Accept': 'application/json'},
          body: new FormData(form)
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          if (errorBox) { errorBox.textContent = data.description || data.message || 'Der Artikel konnte nicht hinzugefügt werden.'; errorBox.hidden = false; }
          return;
        }
        window.KfzCartDrawer.open();
      } catch (error) {
        form.submit();
      } finally {
        addButton.disabled = false;
        addButton.textContent = label;
      }
    });
    root.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
      if (!input.value || !input.validity.valid) input.value = input.min || 1;
      if (button.dataset.step === '1') input.stepUp(); else input.stepDown();
      input.dispatchEvent(new Event('change', {bubbles: true}));
    }));
    root.querySelector('[data-variant]')?.addEventListener('change', event => {
      const url = new URL(location.href);
      url.searchParams.set('variant', event.target.value);
      location.assign(url);
    });
    root.querySelectorAll('[data-thumbnail]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-image]').forEach(image => { image.hidden = image.dataset.image !== button.dataset.thumbnail; });
      root.querySelectorAll('[data-thumbnail]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));
    const dialog = root.querySelector('dialog');
    root.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
      dialog.querySelector('img').src = button.querySelector('img').src;
      dialog.showModal();
    }));
    dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    const track = root.querySelector('.kfx-related-track');
    if (track) {
      const cards = [...track.querySelectorAll('.kfx-card')];
      const controls = root.querySelector('.kfx-carousel-controls');
      const previous = controls.querySelector('[data-page-step="-1"]');
      const next = controls.querySelector('[data-page-step="1"]');
      let pageIndex = 0;
      let pageSize = 0;
      const renderPage = () => {
        const newSize = Number(getComputedStyle(track).getPropertyValue('--kfx-page-size')) || 1;
        if (pageSize && pageSize !== newSize) pageIndex = Math.floor(pageIndex * pageSize / newSize);
        pageSize = newSize;
        const pageCount = Math.ceil(cards.length / pageSize);
        pageIndex = Math.max(0, Math.min(pageIndex, pageCount - 1));
        cards.forEach((card, index) => { card.hidden = index < pageIndex * pageSize || index >= (pageIndex + 1) * pageSize; });
        controls.hidden = pageCount <= 1;
        previous.disabled = pageIndex === 0;
        next.disabled = pageIndex >= pageCount - 1;
        controls.querySelector('output').textContent = `${pageIndex + 1} / ${pageCount}`;
      };
      controls.querySelectorAll('[data-page-step]').forEach(button => button.addEventListener('click', () => {
        pageIndex += Number(button.dataset.pageStep);
        renderPage();
      }));
      const resizeObserver = new ResizeObserver(() => {
        if (!root.isConnected) { resizeObserver.disconnect(); return; }
        renderPage();
      });
      resizeObserver.observe(track);
      renderPage();
    }
  }
  document.querySelectorAll('[data-accessory-section]').forEach(setupAccessory);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-accessory-section]').forEach(setupAccessory));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
